<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_cu17"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('evaluation_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button v-if="getLimit('evaluation_push_button')" @click="funcSend">
          推送
        </el-button>
        <el-button
          v-if="getLimit('evaluation_setting_button')"
          @click="funcSetUp"
        >
          设置
        </el-button>
        <el-button
          v-if="getLimit('evaluation_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      resizable
      stripe
      highlight-current-row
      border
      highlight-hover-row
      :loading="loading"
      height="80%"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="userName"
          title="名称"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.userName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="phone"
          title="联系方式"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="partyType"
          title="角色"
          min-width="100"
          sortable
          :formatter="formatterPartyType"
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.partyType"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in partyTypOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="avgBasicGrade"
          title="评价分数"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <!-- <el-input
            v-model="listQuery.avgBasicGrade"
            type="number"
            placeholder="请输入评价分数"
            clearable
          /> -->
          <!-- 后台不支持 -->
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.avgBasicGradeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.avgBasicGradeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderTotal"
          title="评价条数"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <!-- <el-input
            v-model="listQuery.orderTotal"
            type="number"
            placeholder="请输入评价条数"
            clearable
          /> -->

          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.orderTotalStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.orderTotalEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" min-width="50" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('evaluation_detail_button')"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button type="text" @click="Shipperlist(scope.row)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('evaluation_unfrozen_button') &&
                scope.row.freezeStatus == 1
            "
            class="item"
            effect="dark"
            content="解冻"
            placement="top"
          >
            <vxe-button type="text" @click="funfrozen(scope.row.userCode, 1)">
              <i class="el-icon-unlock" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-else-if="
              getLimit('evaluation_frozen_button') &&
                scope.row.freezeStatus != 1
            "
            class="item"
            effect="dark"
            content="冻结"
            placement="top"
          >
            <vxe-button type="text" @click="funfrozen(scope.row.userCode, 0)">
              <i class="el-icon-lock" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="tuteship"
      title="评价详情"
      width="1300"
      height="80%"
      resize
    >
      <detailslist ref="ShipperlRef" />
    </vxe-modal>
    <vxe-modal
      v-model="tuteship2"
      title="评价详情"
      width="1300"
      height="80%"
      resize
    >
      <detailslist2 ref="Shipperl2Ref" />
    </vxe-modal>
    <vxe-modal
      v-model="setUpFlag"
      title="低分设置"
      width="800"
      height="500"
      resize
    >
      <setUp ref="setUpRef" @setUped="setUped" />
    </vxe-modal>
    <vxe-modal
      v-model="pushFlag"
      title="消息推送"
      width="800"
      height="500"
      resize
    >
      <push ref="pushRef" @pushed="pushed" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import { evaluationManagement, freezeParty } from "@/api/CustomerService";
import detailslist from "./components/details.vue";
import detailslist2 from "./components/details2.vue";
import setUp from "./components/setUp.vue";
import push from "./components/push.vue";
export default {
  components: {
    detailslist,
    detailslist2,
    setUp,
    push
  },
  data() {
    return {
      exportObj: {
        exportUrl:
          "/ntocc-basic-api/orderComment/exportEvaluationManagementList", //导出接口
        name: "评价管理"
      },
      tuteship: false,
      tuteship2: false,
      loading: false,
      setUpFlag: false,
      pushFlag: false,
      tableData: [],
      listQuery: {
        pageNum: 1,
        pageSize: 20,
        sortType: "",
        sortField: "",
        total: 0
      },
      partyTypOptions: [
        {
          label: "实际承运人",
          value: "DRIVER"
        },
        {
          label: "车队长",
          value: "DRIVER_LEADER"
        },
        {
          label: "托运人",
          value: "SHIPMENT"
        },
        {
          label: "托运人",
          value: "SHIPMENT_COMPANY"
        }
      ]
    };
  },
  created() {
    this.findList();
  },
  methods: {
    // 推送
    funcSend() {
      const selectRecords = this.$refs.xTable.getCheckboxRecords();
      if (!selectRecords || selectRecords.length === 0) {
        return this.$message({
          message: "请选择需要推送的数据",
          type: "warning"
        });
      } else if (selectRecords.length > 20) {
        return this.$message({
          message: "批量处理最多20条数据",
          type: "warning"
        });
      }
      this.$refs.pushRef.setcodes(selectRecords);
      this.pushFlag = true;
    },
    pushed() {
      this.pushFlag = false;
    },
    // 设置
    funcSetUp() {
      this.setUpFlag = true;
      this.$refs.setUpRef.getInfo();
    },
    setUped() {
      this.setUpFlag = false;
      this.findList();
    },
    async findList() {
      this.loading = true;
      let response = await evaluationManagement(this.listQuery);
      this.tableData = response.data.records;
      this.listQuery.total = response.data.total;
      this.loading = false;
    },
    // 冻结
    funfrozen(code, status) {
      if (status == "0") {
        this.$confirm("确认冻结吗")
          .then(_ => {
            this.setfrozen(code, 1);
          })
          .catch(_ => {});
      } else {
        this.setfrozen(code, 0);
      }
    },
    async setfrozen(code, freezeStatus) {
      const rLoading = this.openLoading();
      let response = await freezeParty({ code, freezeStatus });
      this.$message.success(response.msg);
      rLoading.close();
      this.findList();
    },
    // 评价详情方法
    Shipperlist(row) {
      const code = row.userCode;
      const isShipment =
        row.partyType == "SHIPMENT" || row.partyType == "SHIPMENT_COMPANY";
      if (isShipment) {
        this.$refs.ShipperlRef.getInfo(code);
        this.tuteship = true;
      } else {
        this.$refs.Shipperl2Ref.getInfo(code);
        this.tuteship2 = true;
      }
    },
    // 翻译状态
    formatterPartyType({ cellValue }) {
      const item = this.partyTypOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    }
  }
};
</script>
